import React from 'react';
import Header from '../components/Header';
import FooterLinks from '../components/FooterLinks';
import TermsConditionsSection from '../components/TermsConditionsSection';

const heroStyles = {
  backgroundImage:
    "linear-gradient(180deg, rgba(6, 23, 31, 0.85), rgba(6, 23, 31, 0.85)), url('/assets/images/tc-handshake.jpeg')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const TermsConditions = () => (
  <div className="min-h-screen bg-[#fdfaf6] text-[#626363]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">

    <section className="relative w-full min-h-[50vh] sm:min-h-[55vh] lg:min-h-[60vh]" style={heroStyles}>
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24 text-center text-white">
        <p className="text-xs tracking-[0.4em] uppercase text-[#dde3ec]">Legal Notice</p>
        <h1
          className="mt-4 text-4xl md:text-5xl font-light"
          style={{ fontFamily: "'Playfair Display', 'Times New Roman', serif" }}
        >
          Terms & Conditions
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/85">
          These terms and conditions outline the rules and regulations for the use of Testa Care's website and services.
        </p>
      </div>
    </section>

    <TermsConditionsSection />

    <section className="bg-[#dde3ec] text-[#1f1f1f] py-16 px-6">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-8">
        <p className="text-2xl font-light text-center md:text-left leading-snug">
          Questions about our terms?
        </p>
        <a
          href="mailto:Info@testacare.co.uk"
          className="inline-flex items-center justify-center rounded-full bg-white px-8 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-[#c46422] shadow-md hover:bg-[#fff7f0] transition-colors"
        >
          Email us
        </a>
      </div>
    </section>

    <FooterLinks />
    </div>
  </div>
);

export default TermsConditions;


